import { AxiosRequestConfig } from 'axios'

import apiPath from '../constant/api-path'
import axios from '../utils/axios'

type NewAPIConfig = AxiosRequestConfig & { useNewAPI: boolean }

export const queryString = (params: object): string => {
  const record = params as Record<string, unknown>
  const result = Object.keys(record)
    .map((key) => key + '=' + record[key])
    .join('&')
  return result.length === 0 ? '' : '?' + result
}

export const serviceProductList = (params?: object) => {
  const config: NewAPIConfig = { useNewAPI: true }
  return axios.get(apiPath.PRODUCT_LIST_PATH, {
    params: params || {},
    ...config
  })
}

export const serviceProductMiList = () =>
  axios.get(apiPath.PRODUCT_MI_LIST_PATH)

export const serviceProductChart = ({
  code,
  params = {}
}: {
  code: string
  params?: object
}) => axios.get(apiPath.PRODUCT_CHART_PATH(code), { params })

export const serviceProductDetail = (code: string) =>
  axios.get(apiPath.PRODUCT_DETAIL_PATH(code))

export const serviceProductSimulation = ({
  code,
  params = {}
}: {
  code: string
  params?: object
}) => axios.get(apiPath.PRODUCT_SIMULATION_PATH(code), { params })

export const serviceProductCompareChart = ({
  codes,
  params = {}
}: {
  codes: string[]
  params?: object
}) => {
  const queryCodes = codes.map((row) => `productCodes=${row}`).join('&')
  const query = queryString(params)
  return axios.get(`${apiPath.PRODUCT_COMPARE_PATH}${query}&${queryCodes}`)
}

export const serviceProductShowcase = () => {
  const config: NewAPIConfig = { useNewAPI: true }
  return axios.get(apiPath.PRODUCT_SHOWCASE, config)
}
